import React, { Component } from 'react'
import PropTypes from 'prop-types';
import client from '../Contentful_API/api';
import { withStyles } from '@material-ui/core/styles';
import styles from './Styles';
import Grid from '@material-ui/core/Grid';
import { SimpleShareButtons } from "react-simple-share";


class SinglePoster extends Component {
	constructor() {
		super()
		this.state = { postergraphics: null }
	}


	componentDidMount() {
		client.getEntries({ content_type: 'postergraphics', 'fields.slug': this.props.match.params.slug })
			.then(response => {
				return response.items[0].fields;
			})
			.then(fields => {
				this.setState({
					postergraphics: fields
				});
			})
			.catch(console.error);
	}

	render(props) {
		const { classes } = this.props;

		let title;
		let slug;
		let imageurl;
		let description;

		if (this.state.postergraphics) {
			title = this.state.postergraphics.title;
			imageurl = this.state.postergraphics.publicationmedia?.fields?.file?.url || this.state.postergraphics.publicationmedia?.[0]?.fields?.file?.url || "";
			slug = this.state.postergraphics.slug;
			description = this.state.postergraphics.description;
		}

		return (
			<div className={classes.layout}>
				<Grid container>
					<Grid item md={8}>
						<div className={classes.imageLayout}>
							<img className={classes.img} alt="complex" src={imageurl} crossOrigin="anonymous" />
						</div>
					</Grid>
					<Grid item md={4}>
						<br />
						<div className={classes.eventBody}>
							<h2>{title}</h2>
							<div dangerouslySetInnerHTML={{ __html: description }} />
						</div>
						<div className={classes.socialShare}>
							<h5>Share with</h5>
							<SimpleShareButtons
								url={"https://www.mof.gov.tl/posterdetails/" + slug}
								size="35px"
							/>
						</div>
					</Grid>
				</Grid>
				<br />
			</div>
		);
	}
}

SinglePoster.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SinglePoster);




